import {useParams} from "react-router-dom";

import styled from "styled-components/macro";
import {useCallback, useEffect, useState} from "react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import PostList from "../../components/post_list";
import HeaderData from "../../components/header_data";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity, useLastFeedPos, useStoreCommunity, useUsername} from "../../store/hooks";
import {useLoggedIn, useModal, useSettings} from "../../store";
import {useFeedPosts} from "../../api/feed";
import useAtBottom from "../../utils/use_at_bottom";
import {useFeedDetails} from "../../api/custom_feeds";
import storage from "../../utils/storage";

import NewSortBar from "../../components/new_sort_bar";
import {isPseudoCommunity} from "../../store/communites";
import NewUserWelcome from "../../components/new_user_welcome";
import FeedBar from "../../components/feed_bar";
import SignupPrompt from "../../components/signup_prompt";
import Suspended from "../../components/suspended";
import Pagination from "../../components/pagination";
import CommunityInfo from "../../components/community_info";
import useWindowDimensions from "../../utils/dimensions";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import isStandardBaseCommunity from "../../utils/base_community";
import BackToTop from "../../components/back_to_top";
import PseudoFeeds from "../../components/pseudo_feeds";
import NavLink from "../../components/nav_link";
import {Button} from "@chakra-ui/react";

const NoPosts = styled.div`
text-align: center;
p {
  font-size: 17px;
  padding-top: 48px;
  padding-bottom: 16px;
  font-weight: 500;
}`;

const Listing = ({sortBy, customFeed}) => {

    const loggedIn = useLoggedIn();
    const username = useUsername();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity, feedId} = useParams();
    const community = (paramsCommunity || baseCommunity).toLowerCase() === "win" ? (customFeed ? 'win' : (loggedIn ? 'home' : 'trending')) : (paramsCommunity || baseCommunity).toLowerCase();
    const style = useCommunityStyle(community);
    const scrollToTop = useCallback(() => {
        document.scrollingElement.scrollTop = 0;
    }, []);

    const feedback = useFeedback();

    const {expand, is_suspended = false, infinite_scroll, blocked_communities, scroll_top, profile_picture, subscribed} = useSettings();
    const {sort = 'week', from} = useQuery();

    const isTrending = (community === "all" || community === "win" || community === "trending") && !feedId;
    const trendingType = isTrending ? (community === "trending" ? "Trending" : "All") : false;
    const trendingTopics = isTrending ? (trendingType === "All" ? [] : ["Politics"]) : [];

    // feed restore logic
    const feedKey = `c/${community}:${sortBy}:${sort}${(feedId && (community === 'win' || community === 'all')) ? `:${feedId}` : ''}${(!feedId && (community === 'win' || community === 'all' || community === 'trending')) ? `:isTrendingTopics:${trendingTopics}:${blocked_communities}` : ''}`;

    const [lastFeedPos, setLastFeedPos] = useState(useLastFeedPos());

    const [hasRestored, setHasRestored] = useState(false);

    const shouldAttemptRestore = lastFeedPos.key === feedKey && !hasRestored;

    const {posts, loading, loadNextPage, refresh, more, restoredFromMemory} = useFeedPosts(feedback.channel, feedKey, isTrending ? "all" : community, sortBy, sort, feedId, trendingTopics, from, shouldAttemptRestore);
    useEffect(scrollToTop, [scrollToTop, community, sortBy, sort]);

    const shouldJumpToPos = !hasRestored && restoredFromMemory;

    const storeCommunity = useStoreCommunity(community);
    const isStandardBase = isStandardBaseCommunity();
    const title = storeCommunity.display_name ? storeCommunity.display_name : (isStandardBase ? 'Scored' : 'The Donald');
    const detector = useAtBottom(loadNextPage);

    const [mobileDismissed, setMobileDismissed] = useState(() => storage.getItem("dismissedMobileWelcome"));
    const [welcomeDismissed, setWelcomeDismissed] = useState(() => parseInt(storage.getItem("has_onboarded")));

    const feedDetails = useFeedDetails(feedback.channel, feedId, customFeed);

    const InFeedItems = {
   /*     "home": {3: <HomeCommunitySuggestions />},
         "all": {3: <TrendingTopicsPrompt />},*/
    };

    const {width} = useWindowDimensions();

    const [scrollY, setScrollY] = useState(0);

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const modal = useModal();

/*    useEffect(() => {
        const dismissedNoticeProfilePicture = localStorage.getItem('dismissedNoticeProfilePicture');
        if (!dismissedNoticeProfilePicture && loggedIn && profile_picture?.length === 0) {
            // open modal
            modal.open(NoticeProfilePicture);
        }
    }, [loggedIn, profile_picture]);*/

    const emptyHome = loggedIn && community.toLowerCase() === "home" && subscribed.length === 0;

    return (
        <>
            <HeaderData ogImageUrlOverride={isPseudoCommunity(community) ? false : `https://scored.co/social/community/${storeCommunity?.name}`} title={title} showBrand={false} community={community} community_style={style}/>
            <Header>
                {/*{!mobileDismissed && <MobilePromo setDismissed={setMobileDismissed} />}*/}
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} customFeed={(username && feedDetails?.author === username) && feedDetails} topics={community === 'win' || community === 'all'} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community} refresh={refresh}/>
                        {baseCommunity !== "TheDonald" &&
                            <CommunityInfo desktop community={community}/>
                        }
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar refresh={refresh} />}
            </Header>
            <SortBar community={community} timeframe={sort} sort={sortBy} refresh={refresh} customFeed={customFeed && feedDetails}/>
            <Container>
                <Wrapper>
                    {(!welcomeDismissed || welcomeDismissed < 4) && isPseudoCommunity(community) && !loggedIn && !feedId &&
                        <NewUserWelcome setWelcomeDismissed={setWelcomeDismissed} />
                    }
                    {is_suspended &&
                        <Suspended />
                    }
                    {feedDetails &&
                        <FeedBar feed={feedDetails} />
                    }

                    {baseCommunity !== "TheDonald" && <PseudoFeeds sort={sortBy} timeFrame={sort} community={community}/>}

                    {emptyHome &&
                        <NoPosts>
                            <p>No posts yet.</p>
                            <NavLink href={"/c/trending"} react_route>
                                <Button variant={"blue"} style={{margin: '0 auto', textAlign: 'center'}}>Go to Trending</Button>
                            </NavLink>
                        </NoPosts>
                    }

                    <Main>
                        {!emptyHome &&
                            <PostList
                                feedKey={feedKey}
                                hideBlocked
                                initialExpand={expand}
                                posts={posts}
                                show_community={community === 'win' || community === 'all' || community === 'home' || community === 'trending'}
                                loading={loading}
                                sort={sortBy}
                                inFeed={!feedId && InFeedItems[community]}
                                showAds
                                jumpToPos={shouldJumpToPos && shouldAttemptRestore && lastFeedPos.id}
                                setHasRestored={setHasRestored}
                            />
                        }
                                {infinite_scroll && detector}
                    </Main>
                    {scroll_top && scrollY > 700 && <BackToTop scrollToTop={scrollToTop}/>}
                    {!infinite_scroll && posts && posts.length > 0 && <Pagination hidePrevious path={`?from=${posts[posts.length - 1].uuid}${sortBy === "top" ? `&sort=${sort}` : ''}`} has_more={more}/>}
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} topics={community === 'win' || community === 'all'} showPseudoFeed community={community} customFeed={(username && feedDetails?.author === username) && feedDetails}/>
            </Container>
            {!loggedIn && <SignupPrompt community={community} message={isPseudoCommunity(community) ? 'With an account, you can vote and create posts.' : `With an account, you can join and participate in ${community}.`} />}
            <Footer/>
        </>
    );
};

export default Listing;
